import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const FETCH_AUDIT_SEARCH_USERS = `${FETCH_USERS_PAGINATED}_FETCH_AUDIT_SEARCH_USERS`
export const FETCH_AUDIT_SEARCH_USERS_SUCCESS = `${FETCH_AUDIT_SEARCH_USERS}_SUCCESS`

export const FETCH_AUDIT_LOGS = 'FETCH_AUDIT_LOGS'
export const FETCH_AUDIT_LOGS_SUCCESS = `${FETCH_AUDIT_LOGS}_SUCCESS`

export const AGGREGATE_AUDIT_EVENTS = 'AGGREGATE_AUDIT_EVENTS'
export const AGGREGATE_AUDIT_EVENTS_SUCCESS = `${AGGREGATE_AUDIT_EVENTS}_SUCCESS`
